import React from 'react';

import {
  VerticalAlignBottomOutlined,
  VerticalAlignCenterOutlined,
  VerticalAlignTopOutlined,
} from '@mui/icons-material';
import { ToggleButton } from '@mui/material';

import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';
import ImageDimensionsInput from './special-inputs/ImageDimensionsInput';
import ImageUploadInput from './special-inputs/ImageUploadInput';

const ImageSidebarForm = createBlockInputSection({
  title: 'Image block',
  inputs: [
    ImageUploadInput,
    ImageDimensionsInput,
    {
      type: 'toolbar-toggle',
      props: {
        label: 'Alignment',
        name: 'contentAlignment',
        defaultValue: 'middle',
        children: [
          <ToggleButton key={0} value="top">
            <VerticalAlignTopOutlined fontSize="small" />
          </ToggleButton>,
          <ToggleButton key={1} value="middle">
            <VerticalAlignCenterOutlined fontSize="small" />
          </ToggleButton>,
          <ToggleButton key={2} value="bottom">
            <VerticalAlignBottomOutlined fontSize="small" />
          </ToggleButton>,
        ],
      },
    },
    { type: 'text', props: { label: 'Alt text', name: 'alt' } },
    { type: 'text', props: { label: 'Click through URL', name: 'linkHref' } },
    'backgroundColor',
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default ImageSidebarForm;
